import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { NotificationImportanceLevel } from '../../../../core/api/models';

@Directive({
  selector: '[notificationsIcon]',
  standalone: true,
})
export class NotificationsIconDirective {
  @Input('notificationsIcon') importanceLevel: NotificationImportanceLevel;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList() {
    let icon = 'mdi mdi-18px tw-ml-1 ';
    switch (this.importanceLevel) {
      case NotificationImportanceLevel.LowImportance:
        icon += '';
        break;
      case NotificationImportanceLevel.NormalImportance:
        icon += 'text-warning mdi-alert-outline';
        break;
      case NotificationImportanceLevel.HighImportance:
        icon += 'text-danger mdi-car-brake-alert';
        break;
      default:
        break;
    }

    return icon;
  }
}
